import React from 'react';
import { DropTarget } from 'react-dnd';
import {DivTitleDrag} from './styled';
const target = {
  drop(props, monitor) {
    if (!monitor.didDrop()) {
      props.onDrop(monitor.getItem());
    }
  }
};

const SeparatorContent = ({ direction, connectDropTarget, isOverCurrent, canDrop }) => (
  <div style={{
    position: 'relative',
    zIndex: 300,
    backgroundColor: '#b535e5'
  }}>
    {connectDropTarget(
      <div style={{
        display: canDrop ? 'flex' : 'none',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        width: canDrop ? '100%' : 0,
        height: canDrop ? 30 : 0,
        top: direction === 'vertical' ? 0 : -15,
        left: direction === 'vertical' ? 0 : 0
      }}>
        {isOverCurrent ? (<div style={{
          width: direction === 'vertical' ? 4 : '100%',
          height: direction === 'vertical' ? '100%' : 4,
          borderRadius: 2,
          backgroundColor: '#4cb9ea'
        }}/>) : null}
        {isOverCurrent ? (<DivTitleDrag/>) : null}
      </div>
    )}
  </div>
);
export default DropTarget('Content', target, (connect, monitor) => ({
  isOverCurrent: monitor.isOver({ shallow: true }),
  connectDropTarget: connect.dropTarget(),
  canDrop: monitor.canDrop(),
}))(SeparatorContent);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/SeparatorContent.js